import { createSelector } from '@reduxjs/toolkit'; // TODO: import from `~/lib/redux` instead
import { settings } from '../../settings';
const teamPinsSlice = (state) => state[`${settings.uid}/teamPins`];
export const selectTeamPins = createSelector([teamPinsSlice], (teamPins) => teamPins);
